import ApiService from '@/services/core/api.service'

const ItemService = {
  async get (query) {
    return ApiService.get(`user/items?${query}`)
  }
}

export default ItemService
